<template>
    <!-- SEARCH -->
    <div class="header-search" >
        <div class="header-search__content" :class="isZeborne ? 'zeborne' : 'mcp'">
            <span class="magnifying-glass"></span>
            <span class="header-search__content-text">Que recherchez-vous ?</span>
        </div>

        <div id="search-bar" class="search-bar-container" style="padding-top: 41px;">
            <div class="header-search-overlay"></div>
            
            <form id="search_mini_form" :action="baseUrl + '/catalogsearch/result/'" method="get">
                <span id="btn_close_search" class="icon icon-search-cross " :class="isZeborne ? 'zeborne' : 'icon-close mcp'"></span>

                <!-- Search Box -->
                <div id="algolia-searchbox">
                    <span id="algolia-glass" class="magnifying-glass" width="24" height="24"></span>
                    <span class="algolia-autocomplete" style="position: relative; display: inline-block; direction: ltr;" id="algolia-autocomplete-tt">
                        <input 
                            id="search" 
                            type="text" 
                            name="q" 
                            class="input-text algolia-search-input aa-input" 
                            autocomplete="off" 
                            spellcheck="false" 
                            autocorrect="off" 
                            autocapitalize="off" 
                            placeholder="Rechercher un produit, un service, un conseil ,..." 
                            role="combobox" 
                            aria-autocomplete="list" 
                            aria-expanded="false" 
                            aria-labelledby="search" 
                            aria-owns="algolia-autocomplete-listbox-0" 
                            dir="auto" style="position: relative; vertical-align: top;"
                        >
                        <pre aria-hidden="true" style="position: absolute; visibility: hidden; white-space: pre; font-family: Roboto-Medium, sans-serif; font-size: 16px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;"></pre>
                    </span>
                    <span class="clear-cross clear-query-autocomplete" :class="isZeborne ? 'zeborne' : 'mcp'"></span>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import '@/includes/Header/SearchBar/SearchBar.scss';
import { mapGetters } from "vuex";

export default {
    name: "SearchBar",
    
    props: {
        baseUrl: {
            type: String,
            required: false,
            default: process.env.VUE_APP_API_BASE_URL
        },
    },

    computed: {
    ...mapGetters({ isZeborne: "isZeborne" }),
    
  },
}
</script>
